export const DRAWER_PADDING_OFFSET = 100;